"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetPage = void 0;
var WidgetPage;
(function (WidgetPage) {
    WidgetPage["MAIN"] = "MAIN";
    WidgetPage["EPISODE"] = "EPISODE";
    WidgetPage["SUBSCRIBE"] = "SUBSCRIBE";
})(WidgetPage || (WidgetPage = {}));
exports.WidgetPage = WidgetPage;
//# sourceMappingURL=constants.js.map